import Mediator from "../services/Mediator";
import {UNDO, REDO, UPDATE_UNDO_REDO} from "../constants/action-types";

export const undo = () => (dispatch) => {
  const {index, lengthOfCommands} = Mediator.undo();

  dispatch({
    type: UNDO,
    payload: {
      canUndo: index > 0,
      canRedo: index !== lengthOfCommands
    }
  });
};
export const redo = () => (dispatch) => {
  const {index, lengthOfCommands} = Mediator.redo();

  dispatch({
    type: REDO,
    payload: {
      canUndo: index > 0,
      canRedo: index !== lengthOfCommands
    }
  });
};

export const updateUndoRedo = () => (dispatch) => {
  const {index, lengthOfCommands} = Mediator.getStateOfHistory();
  dispatch({
    type: UPDATE_UNDO_REDO,
    payload: {
      canUndo: index > 0,
      canRedo: index !== lengthOfCommands
    }
  });
};
